import React from 'react';
import { render } from 'react-dom';
import { BrowserRouter as Router } from 'react-router-dom';
import { configure } from 'mobx';

import './index.scss';

import App from './App';
import { StoreProvider, store } from './stores';
import { unregister } from './serviceWorker';

configure({
    enforceActions: 'never',
    computedRequiresReaction: false,
    reactionRequiresObservable: false,
    observableRequiresReaction: false,
    disableErrorBoundaries: true,
});

render(
    <Router basename={process.env.PUBLIC_URL || '/'}>
        <StoreProvider value={store}>
            <App/>
        </StoreProvider>
    </Router>,
    document.getElementById('root'),
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
unregister();
